"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomEventsTracker = void 0;
/* eslint-disable no-console */
const tracker_1 = require("../tracker");
var DomEventsTypes;
(function (DomEventsTypes) {
    DomEventsTypes["ViewModule"] = "evTrackViewModule";
    DomEventsTypes["ActionModule"] = "evTrackActionModule";
})(DomEventsTypes || (DomEventsTypes = {}));
class DomEventsTracker extends tracker_1.Tracker {
    constructor(config, objectKeyFormatter = null) {
        const viewModuleEventType = config.viewModuleEventType || DomEventsTypes.ViewModule;
        const actionModuleEventType = config.actionModuleEventType || DomEventsTypes.ActionModule;
        delete config.actionModuleEventType;
        delete config.viewModuleEventType;
        super(config, objectKeyFormatter);
        this.id = 'dom-event';
        this.viewModuleEventType = '';
        this.actionModuleEventType = '';
        this.sendInfo = (data) => {
            var _a;
            const info = {
                customData: Object.assign({}, data),
            };
            info.customData = this.parseData(info.customData);
            const eventName = this.isViewTagView(data) ? this.viewModuleEventType : this.actionModuleEventType;
            try {
                const taggingEvent = new CustomEvent(eventName, {
                    detail: info,
                    bubbles: false,
                    cancelable: false,
                });
                (_a = window.document) === null || _a === void 0 ? void 0 : _a.dispatchEvent(taggingEvent);
            }
            catch (e) {
                const taggingEvent = window.document.createEvent('CustomEvent');
                taggingEvent.initCustomEvent(eventName, false, false, info);
                window.document.dispatchEvent(taggingEvent);
            }
        };
        this.viewModuleEventType = viewModuleEventType;
        this.actionModuleEventType = actionModuleEventType;
    }
    isViewTagView(data) {
        return data.pageName !== undefined;
    }
}
exports.DomEventsTracker = DomEventsTracker;
//# sourceMappingURL=DomEventsTracker.js.map